<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.eicb_cd_codigo }} - {{ $t('descricao') }} :
								{{ item.cbgm_ds_descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVProcessamentoCubagem()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:properties="dataObject"
					:options="kebabOptions"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:backdrop="!planejamentoModelo"
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
		>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 1rem">
					<InputText
						v-model="model.eicb_ds_descricao"
						:label="$t('description')"
						@input="onDescriptionChange"
					/>

					<DropdownFk
						id="dropdown_cubagem"
						v-model="model.fk_cbgm_cubagem"
						:disabled="isEdit"
						:label="$t('logging')"
						:dropdown-options="cubagens"
					/>

					<RadioButtons
						v-if="!planejamentoModelo"
						v-model="afilamentoVolumetrico"
						group-name="tipo-processamento"
						:label="$t('typeOfProcessing')"
						:options="[
							{ label: $t('volumetric'), value: 'volumetrico' },
							{ label: $t('taper'), value: 'afilamento' },
						]"
						:disabled="isEdit"
					/>
				</div>

				<h4
					v-show="!isEdit"
					class="text-xl font-bold mt-4"
					style="margin-bottom: 0"
				>
					{{ $t('processingModel') }}
				</h4>
				<p v-show="!isEdit">
					{{ $t('helpProcessingModel') }}
				</p>

				<div style="gap: 1.5rem; padding: 1rem 0">
					<div style="display: flex; gap: 1rem">
						<CardPicker
							v-show="!isEdit"
							soon
							:selected="!avancado"
						>
							<template #header>
								{{ $t('automatic') }}
							</template>
							<template #description>
								{{ $t('helpAutomatic') }}
							</template>
							<template #button-title>
								{{ !avancado ? $t('selected') : $t('select') }}
							</template>
						</CardPicker>

						<CardPicker
							v-show="!isEdit"
							:selected="avancado"
							@click="handleClick('avancado')"
						>
							<template #header>
								{{ $t('advanced') }}
							</template>
							<template #description>
								{{ $t('helpAdvanced') }}
							</template>
							<template #button-title>
								{{ avancado ? $t('selected') : $t('select') }}
							</template>
						</CardPicker>
					</div>

					<div style="display: flex; justify-content: space-between; padding: 0.5rem 0">
						<div />
						<p
							v-if="isEdit"
							class="go__to__plan__text"
							@click="verPlanejamento"
						>
							<Loading
								v-if="!modeloSalvo"
								style="width: fit-content"
							/>
							<span v-if="modelos.length > 1">{{ $t('continuarParaAescolha') }} ➝ </span>
							<span v-else>{{ `${$t('view')} ${$t('model')} ➝` }}</span>
						</p>
					</div>
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('cancel')"
						color="trv-secondary"
						outlined
						semantic-class="mini"
						@click="changeFormAndCloseAllActions"
					/>
					<Button
						v-if="!isEdit"
						:label="
							avancado
								? isEdit
									? $t('edit')
									: $t('continue')
								: isEdit
									? $t('edit')
									: $t('process')
						"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						v-if="descriptionChanged"
						:label="$t('save')"
						color="trv-default"
						@click="update"
					/>
				</div>

				<!-- <div class="container__crud__crudform__buttons">
          <Button :label="avancado ? $t('continue') : $t('process')" color="trv-default" semanticClass="mini"
            :disabled="disableSaveButton || !camposObrigatoriosPreenchidos" @click="saveClick()" />
          <Button :label="$t('cancel')" color="trv-default" semanticClass="mini" @click="changeFormAndCloseAllActions"
            outlined />
        </div> -->
			</template>
		</CrudForm>
		<ProcessamentoAvancado
			v-if="planejamentoModelo"
			:modelo="modelos[index]"
		>
			<template #registry-fields>
				<div
					id="registry__fields"
					style="padding: 1.5rem; height: 100%; display: flex; flex-direction: column; gap: 1rem"
				>
					<InputText
						v-model="model.eicb_ds_descricao"
						:label="$t('description')"
					/>
					<DropdownFk
						id="dropdown_cubagem"
						v-model="model.fk_cbgm_cubagem"
						:disabled="isEdit"
						:label="$t('logging')"
						:dropdown-options="cubagens"
					/>

					<RadioButtons
						v-model="afilamentoVolumetrico"
						group-name="tipo-processamento"
						:label="$t('typeOfProcessing')"
						:options="[
							{ label: $t('volumetric'), value: 'volumetrico' },
							{ label: $t('taper'), value: 'afilamento' },
						]"
					/>
				</div>
			</template>

			<template #modeling-preview>
				<ModelPreviewTemp
					v-if="modelos.length"
					v-model="modeloEscolhido"
					:edit="isEdit"
					:help="help"
					:model="modelos[index] || {}"
					@search="searchModel"
				>
					<div>
						<div
							v-if="modelos.length > 1"
							style="display: flex; justify-content: center"
						>
							<Tag
								:label="`${index + 1}/${modelos.length}`"
								class-name="default outlined"
							/>
						</div>
						<div
							v-if="modelos.length > 1"
							style="
								width: 100%;
								display: flex;
								justify-content: center;
								gap: 1rem;
								margin-bottom: 0.5rem;
								margin-top: 0.5rem;
								padding: 0 5rem;
							"
						>
							<Button
								:disabled="index === 0"
								icon="fas fa-caret-left"
								color="trv-primary"
								semantic-class="tiny"
								@click="index--"
							/>
							<Button
								:loading="escolhendoModelo"
								color="trv-default"
								:label="`${$t('pickModel')}`"
								semantic-class="tiny"
								@click="saveModel"
							/>

							<Button
								:disabled="index === modelos.length - 1"
								icon="fas fa-caret-right"
								semantic-class="tiny"
								color="trv-primary"
								@click="index++"
							/>
						</div>
					</div>
				</ModelPreviewTemp>
				<div
					v-else
					style="
						display: flex;
						flex-direction: column;
						justify-content: center;
						height: 100%;
						align-content: center;
						align-items: center;
					"
				>
					<Loading
						v-if="mostrarLoadingProcessando"
						style="height: 25px; width: 25px"
					/>
					<label style="display: flex; align-items: center; font-size: 1rem; margin-top: 0"
						>{{ mensagemProcessando }}
					</label>
				</div>
			</template>

			<template #action-buttons>
				<div style="display: flex; padding: 1.5rem">
					<Button
						:label="$t('back')"
						color="trv-secondary"
						outlined
						@click="
							planejamentoModelo = false
							showForm = true
						"
					/>
					<Button
						v-show="!isEdit"
						:label="$t('process')"
						semantic-class="tiny"
						:loading="processando"
						:disabled="isEdit"
						@click="registraInventarioCubagem"
					/>
				</div>
			</template>

			<template #checkout-preview>
				<h3 style="text-align: center; padding: 2rem">
					{{ modelos[index] ? modelos[index].stan_nm_modelo : '' }}
				</h3>
				<div style="padding: 1.5rem">
					<Button
						:disabled="!modeloEscolhido"
						:label="$t('save')"
						semantic-class="tiny"
						@click="saveModel"
					/>
				</div>
			</template>
		</ProcessamentoAvancado>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
// import DownloadButton from "../../../components/DownloadButton/DownloadButton";
import CardPicker from '../../../components/CardPicker/CardPicker'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Loading from '../../../components/Loading/Loading'
import Pagination from '../../../components/Pagination/Pagination'
import RadioButtons from '../../../components/RadioButtons/RadioButtons'
import Tag from '../../../components/Tag/Tag'

import ModelPreviewTemp from '../../../components/ModelPreviewTemp/ModelPreviewTemp.vue'
import ProcessamentoAvancado from '../ProcessamentoAvancado.vue'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	ajustaModeloAfilamento,
	ajustaModeloVolumetrico,
	createEstratoInventarioCubagem,
	deleteEstratoInventarioCubagemByIdList,
	getAllAfilamentoWithGraphicByEicbId,
	getAllEstratoInventarioCubagem,
	getAllVolumetricoWithGraphicByEicbId,
	registraEstratoInventarioProcessamento,
	saveChosenAfilamentoModel,
	saveChosenVolumetricoModel,
	updateEstratoInventarioCubagem,
} from '../../../services/requests/EstratoInventarioCubagemRequests'

import { getCubagemDropdown } from '../../../services/requests/CubagemRequests'

import { exportarCsv } from '../../../utils/csvHellpers'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	name: 'ProcessamentoCubagem',
	components: {
		Button,
		CrudForm,
		CrudTable,
		CardPicker,
		KebabMenu,
		Tag,
		RadioButtons,
		Loading,
		ProcessamentoAvancado,
		ModelPreviewTemp,
		// DownloadButton,
		DropdownCheckbox,
		DropdownFk,
		InputSearch,
		InputText,
		Pagination,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	provide() {
		return {
			edit: this.edit,
		}
	},
	data() {
		return {
			modeloSalvo: undefined,
			processando: false,
			escolhendoModelo: false,
			descriptionChanged: false,
			showExclusionAlert: false,
			initialDescription: '',
			headersSelecionados: [
				'eicb_dt_processamento',
				'cubagem',
				'eicb_tx_tipo_modelo',
				'eicb_ds_descricao',
				'eicb_cd_codigo',
				'nomeModelo',
			],
			intention: {},
			help: {},
			modeloEscolhido: '',
			index: 0,
			modelos: [],
			afilamentoVolumetrico: 'volumetrico',
			avancado: true,
			planejamentoModelo: false,
			mostrarLoadingProcessando: false,
			mensagemProcessando: this.$t('realizeOProcessamento'),
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				eicb_ds_descricao: '',
				eicb_tx_tipo_modelo: 'Volumetrico',
				fk_cbgm_cubagem: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'PC',
				subtitleCardPropertie: 'eicb_ds_descricao',
				titleCardPropertie: 'eicb_cd_codigo',
			},

			tableHeaders: [
				{ key: 'eicb_cd_codigo', value: this.$t('code'), isActive: true },
				{
					key: 'eicb_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'eicb_tx_tipo_modelo',
					value: this.$t('adjustedModel'),
					isActive: true,
				},
				{ key: 'cubagem', value: this.$t('logging'), isActive: true },
				{
					key: 'eicb_dt_processamento',
					value: this.$t('processedDate'),
					isActive: true,
				},
				{
					key: 'nomeModelo',
					value: this.$t('model'),
					isActive: true,
				},
			],
			/**
			 * Cubagens para exibir no dropdown
			 */
			cubagens: [],
		}
	},
	computed: {
		edit() {
			return this.isEdit
		},
		modeloSelecionado() {
			return this.modelos.find((f) => f.stan_nm_variavel_modelo === this.modeloEscolhido)
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return (
				this.model.fk_cbgm_cubagem && this.model.eicb_ds_descricao && this.model.eicb_tx_tipo_modelo
			)
		},
	},

	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => {
				return model.id === value.properties.id
			})

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
				case 'visualizar':
					var get =
						model.eicb_tx_tipo_modelo === 'Volumetrico'
							? getAllVolumetricoWithGraphicByEicbId
							: getAllAfilamentoWithGraphicByEicbId

					this.mutationShowMessage({
						messageTitle: this.$t('buscandoModelo'),
						messageText: '',
						messageIcon: 'far fa-info-circle',
						messageType: 'info',
					})

					get(model.id).then((response) => {
						this.isEdit = true
						this.model = model
						this.modelos = response.data.result
						this.planejamentoModelo = true
					})
					break
			}
		},
		afilamentoVolumetrico: {
			handler(value) {
				this.model.eicb_tx_tipo_modelo = value === 'volumetrico' ? 'Volumetrico' : 'Afilamento'
			},
			immediate: true,
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['eicb_cd_codigo']
		getAllEstratoInventarioCubagem().then((response) => {
			const { result: estratosInventarioCubagem } = response.data
			estratosInventarioCubagem.forEach((estratoInventarioCubbagem) =>
				this.formataEstratoInventarioCubagemParaTabela(estratoInventarioCubbagem),
			)
			this.modelList = estratosInventarioCubagem
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getCubagemDropdown().then((response) => {
			this.cubagens = response
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		onDescriptionChange(value) {
			if (this.isEdit) {
				this.descriptionChanged = this.descricao !== value
			}
		},
		verPlanejamento() {
			if (this.modelos.length) {
				this.planejamentoModelo = true
				this.showForm = false
			}
		},
		deletaProcessamento(estratoInventarioCubagemId) {
			deleteEstratoInventarioCubagemByIdList(estratoInventarioCubagemId).then(() => {
				const indexToRemove = this.modelList.map((m) => m.id).indexOf(estratoInventarioCubagemId)
				this.modelList.splice(indexToRemove, 1)
			})
		},
		handleInput(e) {
			this.headersSelecionados = e.map((m) => m.key)
		},
		saveModel() {
			this.escolhendoModelo = true
			let saveChosenModel =
				this.model.eicb_tx_tipo_modelo === 'Afilamento'
					? saveChosenAfilamentoModel
					: saveChosenVolumetricoModel

			this.mutationShowMessage({
				messageTitle: this.$t('aviso'),
				messageText: this.$t('salvandoModelo'),
				messageIcon: 'far fa-check-circle',
				messageType: 'info',
			})

			saveChosenModel({
				eicbId: this.model.id,
				cubagemId: this.model.fk_cbgm_cubagem,
				chosenModelName: this.modelos[this.index].stan_nm_variavel_modelo,
			})
				.then(() => {
					this.escolhendoModelo = false
					this.planejamentoModelo = false
					this.processando = false
					this.isEdit = true
					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})

					var get =
						this.model.eicb_tx_tipo_modelo === 'Volumetrico'
							? getAllVolumetricoWithGraphicByEicbId
							: getAllAfilamentoWithGraphicByEicbId

					get(this.model.id).then((response) => {
						this.modelos = response.data.result
						this.modeloSalvo = response.data.result
					})
				})
				.catch(() => {
					this.planejamentoModelo = false
					this.processando = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('falhaAoCriarProcessamento'),
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})

					this.deletaProcessamento([this.model.id])
				})
		},
		searchModel(text) {
			let modelo = this.modelos.find((modelo) =>
				modelo.stan_nm_titulo_modelo.toLowerCase().includes(text.toLowerCase()),
			)

			if (modelo) {
				this.index = this.modelos.indexOf(modelo)
				this.help = {}
			} else this.help = { message: this.$t('modelNotFound'), type: 'warning' }
		},
		handleClick(tipo) {
			this.avancado = tipo === 'avancado'
		},
		async registraInventarioCubagem() {
			this.processando = true
			this.mostrarLoadingProcessando = true
			this.mensagemProcessando = 'Aguarde enquanto os modelos são gerados'

			this.mutationShowMessage({
				messageTitle: this.$t('aviso'),
				messageText: this.$t('modelosGerados'),
				messageIcon: 'far fa-check-circle',
				messageType: 'info',
			})
			await registraEstratoInventarioProcessamento({
				eicb_ds_descricao: this.model.eicb_ds_descricao,
				fk_cbgm_cubagem: this.model.fk_cbgm_cubagem,
				eicb_tx_tipo_modelo: this.model.eicb_tx_tipo_modelo,
				eicb_dt_processamento: new Date(),
				eicb_dt_referencia: new Date(),
			})
				.then((response) => {
					this.model.id = response.data.result.id
					console.log(response)

					let treino

					if (response.status === 200) {
						treino =
							this.model.eicb_tx_tipo_modelo === 'Afilamento'
								? ajustaModeloAfilamento
								: ajustaModeloVolumetrico

						treino({
							EicbId: this.model.id,
							CubagemId: this.model.fk_cbgm_cubagem,
						})
							.then((response) => {
								this.modelos = response.data.result
								this.processando = false
								this.mostrarLoadingProcessando = false
							})
							.catch(() => {
								this.planejamentoModelo = false
								this.mostrarLoadingProcessando = false
								this.processando = false
								this.mutationShowMessage({
									messageTitle: this.$t('erro'),
									messageText: this.$t('falhaAoCriarProcessamento'),
									messageIcon: 'far fa-cross-circle',
									messageType: 'error',
								})

								this.deletaProcessamento([this.model.id])
							})
					}
				})
				.catch(() => {
					this.planejamentoModelo = false
					this.mostrarLoadingProcessando = false
					this.processando = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('falhaAoCriarProcessamento'),
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})

					this.deletaProcessamento([this.model.id])
				})
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createEstratoInventarioCubagemToPost() {
			return {
				id: uuidv4(),
				eicb_ds_descricao: this.model.eicb_ds_descricao,
				eicb_tx_tipo_modelo: this.model.eicb_tx_tipo_modelo,
				fk_cbgm_cubagem: this.model.fk_cbgm_cubagem,
			}
		},

		/**
		 * Cria novo Estrato inventario cubagem no banco de dados
		 */
		create() {
			const estratoInventarioCubagem = this.createEstratoInventarioCubagemToPost()
			console.log(
				'🚀 ~ file: Cubagem.vue:444 ~ create ~ estratoInventarioCubagem',
				estratoInventarioCubagem,
			)

			createEstratoInventarioCubagem(estratoInventarioCubagem).then((response) => {
				const { result: estratoInventarioCubagem, isError } = response.data

				console.log('🚀 ~ file: Cubagem.vue:483 ~ create ~ response', response)

				this.disableSaveButton = false

				if (!isError) {
					this.cleanModel()
					this.formataEstratoInventarioCubagemParaTabela(estratoInventarioCubagem)

					this.modelList.unshift(estratoInventarioCubagem)

					this.showForm = false
					this.emptyValue = ''

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataEstratoInventarioCubagemParaTabela(estratoInventarioCubagem) {
			estratoInventarioCubagem.isCheckedToDelete = false
			estratoInventarioCubagem.eicb_dt_processamento =
				estratoInventarioCubagem.eicb_dt_processamento
					? new Date(estratoInventarioCubagem.eicb_dt_processamento).toLocaleDateString()
					: ''
		},

		/**
		 * Atualiza estrato inventario cubagem no banco de dados
		 */
		update() {
			// Converte eicb_dt_processamento para o formato ISO 8601
			if (this.model.eicb_dt_processamento) {
				const dateParts = this.model.eicb_dt_processamento.split('/')
				const formattedDate = new Date(
					`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`,
				).toISOString()
				this.model.eicb_dt_processamento = formattedDate
			}
			updateEstratoInventarioCubagem(this.model).then((response) => {
				const { result: estratoInventarioCubagem, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.formataEstratoInventarioCubagemParaTabela(estratoInventarioCubagem)
					const indexModel = this.modelList.map((m) => m.id).indexOf(estratoInventarioCubagem.id)
					this.$set(this.modelList, indexModel, estratoInventarioCubagem)

					this.showForm = false
					this.descriptionChanged = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					window.location.reload()
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui estrato inventario cubagem no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(estratoInventarioCubagem) =>
						this.modelsIdWithCheckedToDelete.includes(estratoInventarioCubagem.id) &&
						estratoInventarioCubagem.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteEstratoInventarioCubagemByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var estratoInventarioCubagemOrganizados = existeRegistroComDependencia
						.map(
							(estratoInventarioCubagem) =>
								`• ${estratoInventarioCubagem.eicb_cd_codigo} - ${estratoInventarioCubagem.eicb_ds_descricao}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('cubagemAtreladaAInventarioFlorestal')}:</b> <br/><br/> ${estratoInventarioCubagemOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			// this.disableSaveButton = true;
			this.planejamentoModelo = true
			this.showForm = false
			// if (this.isEdit) {
			//   this.update();
			// } else {
			//   this.create();
			// }
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.descricao = this.model.eicb_ds_descricao
			this.afilamentoVolumetrico =
				this.model.eicb_tx_tipo_modelo === 'Volumetrico' ||
				this.model.eicb_tx_tipo_modelo === 'Volumétrico'
					? 'volumetrico'
					: 'afilamento'

			this.titleForm = `${this.$t('edit')} ${this.$t('loggingProcessig')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()

			var get =
				model.eicb_tx_tipo_modelo === 'Volumetrico'
					? getAllVolumetricoWithGraphicByEicbId
					: getAllAfilamentoWithGraphicByEicbId

			get(model.id).then((response) => {
				this.modeloSalvo = response.data.result
				this.modelos = response.data.result
			})
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.model.eicb_tx_tipo_modelo = 'Volumetrico'
			this.afilamentoVolumetrico = 'volumetrico'

			this.titleForm = `${this.$t('create')} ${this.$t('loggingProcessig')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.modeloSalvo = []
			this.modelos = []
		},

		/**
		 * Baixa os registros da tabela de processamento de cubagem
		 */
		downloadCSVProcessamentoCubagem() {
			let cabecalhoDoCsvProcessamentoCubagem = [
				'Código',
				'Descrição',
				'Modelo Ajustado',
				'Cubagem',
				'Data do Processamento',
				'Modelo',
			]
			const items = this.modelList

			const linhas = items.map((item) => [
				item.eicb_cd_codigo,
				item.eicb_ds_descricao,
				item.eicb_tx_modelo_ajustado,
				item.cbgm_ds_descricao,
				item.eicb_dt_processamento,
				item.nomeModelo,
			])

			exportarCsv('export_processamentos_de_cubagem', cabecalhoDoCsvProcessamentoCubagem, linhas)
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
